import { makeStyles } from 'tss-react/mui'
import { Theme } from '@mui/material/styles'

/** Extra left/right breathing room when the history fills the maximized panel. */
const FULL_SCREEN_SIDE_PADDING = 140 // px

export const useStyles = makeStyles()((theme: Theme) => ({
  root: {
    flex: 1,
    minHeight: 0,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.text.white,
    overflow: 'hidden',
  },
  rootFullScreen: {
    paddingLeft: FULL_SCREEN_SIDE_PADDING,
    paddingRight: FULL_SCREEN_SIDE_PADDING,
  },

  // --- Title row ------------------------------------------------------------
  titleRow: {
    flexShrink: 0,
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    padding: `${theme.spacing(2)} ${theme.spacing(3)} ${theme.spacing(2)}`,
  },
  backButton: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.spacing(3),
    height: theme.spacing(3),
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.labraText.darkTertiary,
    '& svg': { fontSize: 14 },
  },
  heading: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 16,
    lineHeight: '24px',
    color: theme.palette.labraText.darkTertiary,
  },

  // --- Search ---------------------------------------------------------------
  searchWrap: {
    flexShrink: 0,
    padding: `0 ${theme.spacing(3)} ${theme.spacing(1)}`,
  },
  searchField: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1.25),
    height: theme.spacing(4.5),
    padding: `0 ${theme.spacing(2)}`,
    borderRadius: 18,
    backgroundColor: theme.palette.labraChat.hoverBg,
    border: `1px solid ${theme.palette.labraChat.border}`,
    transition: 'border-color 120ms',
    '& svg': {
      fontSize: 15,
      color: theme.palette.labraText.secondaryDescription,
    },
  },
  searchFieldFocused: {
    borderColor: theme.palette.textBlueV3.main,
  },
  searchInput: {
    flex: 1,
    minWidth: 0,
    border: 'none',
    outline: 'none',
    background: 'transparent',
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 14,
    color: theme.palette.labraText.darkTertiary,
    '&::placeholder': {
      color: theme.palette.labraText.secondaryDescription,
    },
  },
  clearButton: {
    display: 'flex',
    flexShrink: 0,
    padding: 2,
    border: 'none',
    background: 'transparent',
    cursor: 'pointer',
    color: theme.palette.labraText.secondaryDescription,
    '& svg': { fontSize: 14, color: 'inherit' },
  },

  // --- List -----------------------------------------------------------------
  list: {
    flex: 1,
    minHeight: 0,
    overflowY: 'auto',
    padding: '10px 14px 8px',
  },
  group: {
    marginTop: theme.spacing(1.5),
  },
  groupHeader: {
    display: 'flex',
    alignItems: 'center',
    gap: theme.spacing(1),
    width: '100%',
    padding: `${theme.spacing(1)} ${theme.spacing(1.5)}`,
    border: 'none',
    borderRadius: 6,
    backgroundColor: theme.palette.labraChat.hoverBg,
    cursor: 'pointer',
    '& svg': {
      fontSize: 12,
      color: theme.palette.labraText.secondaryDescription,
    },
  },
  groupDivider: {
    width: 1,
    height: theme.spacing(2.25),
    backgroundColor: theme.palette.labraChat.borderLight,
  },
  lockedBody: {
    padding: `${theme.spacing(1.5)} ${theme.spacing(1.5)} ${theme.spacing(2)}`,
  },
  lockedText: {
    margin: 0,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 400,
    fontSize: 12.5,
    lineHeight: '18px',
    color: theme.palette.labraText.description,
  },
  upgradeButton: {
    display: 'inline-flex',
    alignItems: 'center',
    marginTop: theme.spacing(1),
    padding: `${theme.spacing(0.5)} ${theme.spacing(1.5)}`,
    borderRadius: 4,
    backgroundColor: theme.palette.warnings.main,
    color: theme.palette.labraText.darkTertiary,
    fontFamily: theme.typography.fontFamily,
    fontWeight: 500,
    fontSize: 12,
    lineHeight: '16px',
    textDecoration: 'none',
  },
  groupLabel: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 700,
    fontSize: 11,
    letterSpacing: '0.12em',
    textTransform: 'uppercase',
    color: theme.palette.labraText.secondaryDescription,
  },
  groupHairline: {
    flex: 1,
    height: 1,
    backgroundColor: theme.palette.labraChat.borderLight,
  },
  groupCount: {
    fontFamily: theme.typography.fontFamily,
    fontWeight: 600,
    fontSize: 11,
    color: theme.palette.labraText.secondaryDescription,
  },
  stateMessage: {
    padding: '48px 20px',
    textAlign: 'center',
    fontFamily: theme.typography.fontFamily,
  },
  stateTitle: {
    fontWeight: 600,
    fontSize: 14,
    color: theme.palette.labraText.description,
  },
  stateHint: {
    marginTop: 4,
    fontSize: 13,
    color: theme.palette.labraText.secondaryDescription,
  },
  centerRow: {
    display: 'flex',
    justifyContent: 'center',
    padding: '16px 0',
  },
}))
